<template>
	<div data-tour-scope="setting-couriers">
		<v-main>
			<v-container fluid fill-height>
				<v-layout justify-center align-center v-resize="onResize">
					<v-card width="100%" outlined elevation-0>
						<v-toolbar flat class="border_bottom" shaped>
							<v-toolbar-title>
								{{ this.$vuetify.lang.t('$vuetify.front.subsetting.couriers') }}
							</v-toolbar-title>
							<v-btn class="ml-6" outlined color="primary" data-tour="tutorial" @click="tour.start()"><v-icon left>mdi-school-outline</v-icon>Tutorial guidato</v-btn>
							<v-spacer></v-spacer>
						</v-toolbar>


						<v-data-table
							:headers="headers"
							class="elevation-0 cellanowrap"
							:hide-default-header="isMobile || mobileCards"
							:class="{ mobile: isMobile, 'table-cards': mobileCards }"
							hide-default-footer
							disable-pagination
							disable-sort
							item-key="item._id"
							data-tour="table"
						>
							<template v-slot:body>
								<!-- telefono: ogni corriere diventa una card con logo, attivazione e credenziali -->
								<tbody v-if="mobileCards" class="courier-cards">
									<tr v-for="s in servizi" :key="s.key">
										<td :colspan="headers.length" class="px-3 py-1">
											<key-value-card>
												<template v-slot:title>
													<img :src="s.logo" height="30px" class="d-block" :alt="s.nome" />
												</template>
												<template v-slot:actions>
													<v-switch v-model="modello(s).active" @change="saveSetting(s.indice)" color="primary" class="mt-0 pt-0 mr-2" hide-details></v-switch>
													<v-btn small icon color="primary" :data-tour="s.indice === 0 ? 'expand' : null" :title="checkpresenza(s.indice) ? 'Chiudi' : 'Impostazioni'" @click="extension(s.indice)">
														<v-icon>{{ checkpresenza(s.indice) ? 'mdi-minus' : 'mdi-plus' }}</v-icon>
													</v-btn>
												</template>
												<service-panel
													v-if="checkpresenza(s.indice)"
													:servizio="s"
													:modello="modello(s)"
													:intestazione="false"
													:data-tour="s.indice === 0 ? 'settings' : null"
													@save="saveSetting(s.indice)"
												>
													<v-alert v-if="s.webhook" outlined text type="info" dense class="text-body-2 mb-4">
														Configurare il Webhook in spediscionline inserendo il seguente url <b>{{ s.webhook }}</b>.
													</v-alert>
													<template v-slot:azioni>
														<v-btn v-if="s.connessione" small outlined color="primary" @click="openConnectionCheck(s.connessione)"><v-icon left small>mdi-connection</v-icon>Verifica connessione</v-btn>
														<v-spacer></v-spacer>
													</template>
												</service-panel>
											</key-value-card>
										</td>
									</tr>
								</tbody>
								<tbody v-else>
									<template v-for="s in servizi">
										<tr :key="s.key" class="as-list-row" :class="{ 'as-list-row--open': checkpresenza(s.indice) }" @click="extension(s.indice)">
											<td class="pr-0" style="width: 40px">
												<v-btn small icon :data-tour="s.indice === 0 ? 'expand' : null" :title="checkpresenza(s.indice) ? 'Chiudi' : 'Impostazioni'" @click.stop="extension(s.indice)">
													<v-icon>{{ checkpresenza(s.indice) ? 'mdi-minus' : 'mdi-plus' }}</v-icon>
												</v-btn>
											</td>
											<td>
												<img :src="s.logo" height="30px" class="d-block" :alt="s.nome" />
											</td>
											<td @click.stop>
												<v-switch v-model="modello(s).active" @change="saveSetting(s.indice)" color="primary" class="mt-0" hide-details></v-switch>
											</td>
										</tr>
										<tr v-if="checkpresenza(s.indice)" :key="s.key + '-panel'" class="as-expanded">
											<td :colspan="headers.length" class="py-3">
												<service-panel :servizio="s" :modello="modello(s)" :data-tour="s.indice === 0 ? 'settings' : null" @save="saveSetting(s.indice)">
													<v-alert v-if="s.webhook" outlined text type="info" dense class="text-body-2 mb-4">
														Configurare il Webhook in spediscionline inserendo il seguente url <b>{{ s.webhook }}</b>.
													</v-alert>
													<template v-slot:azioni>
														<v-btn v-if="s.connessione" small outlined color="primary" @click="openConnectionCheck(s.connessione)"><v-icon left small>mdi-connection</v-icon>Verifica connessione</v-btn>
														<v-spacer></v-spacer>
													</template>
												</service-panel>
											</td>
										</tr>
									</template>
								</tbody>
							</template>
						</v-data-table>
					</v-card>
					<v-snackbar v-model="snackbar.snackbar" :color="snackbar.color" :multi-line="snackbar.mode === 'multi-line'" :timeout="snackbar.timeout" :vertical="snackbar.mode === 'vertical'">
						{{ snackbar.text }}
						<v-btn dark text @click="snackbar.snackbar = false"> Close</v-btn>
					</v-snackbar>
				</v-layout>
			</v-container>
		</v-main>
		<TourOverlay :tour="tour"></TourOverlay>
		<marketplace-connection-check v-model="connectionCheck.open" :service="connectionCheck.service"></marketplace-connection-check>
	</div>
</template>

<script>
import axios from 'axios';
import { mapGetters, mapMutations, mapActions } from 'vuex';
import TourOverlay from '@/components/core/tour/TourOverlay.vue';
import KeyValueCard from '@/components/core/KeyValueCard.vue';
import ServicePanel from './components/ServicePanel.vue';
import MarketplaceConnectionCheck from './components/MarketplaceConnectionCheck.vue';
import { useTour } from '@/components/core/tour/useTour';
import { createCouriersTourSteps, stopCouriersTour } from './couriers-tour';

export default {
	name: 'Couriers',
	setup() {
		return { tour: useTour(createCouriersTourSteps(), { onStop: stopCouriersTour }) };
	},
	beforeDestroy() {
		this.tour.stop();
		this.destroyData();
	},
	data() {
		return {
			snackbar: {
				snackbar: false,
				color: '',
				mode: '',
				timeout: 6000,
				text: '',
			},
			// riquadri di configurazione aperti (indice del servizio)
			selected: [],
			// verifica connessione: verifica le impostazioni salvate
			connectionCheck: { open: false, service: 'spedisciOnline' },
			headers: [{ text: '', sortable: false }, { text: 'Corriere', sortable: false }, { text: 'Status', sortable: false }],
			messages: {
				email: [],
				name: [],
				password: [],
			},

			isMobile: false,

			gls: {
				active: false,
				setting: {
					SedeGls: '',
					CodiceClienteGls: '',
					PasswordClienteGls: '',
					CodiceContrattoGls: '',
				},
				type: 'courier',
				service: 'gls',
			},
			spedisciOnline: {
				active: false,
				setting: {
					apikey: '',
					endpoint: '',
					secret: '',
				},
				type: 'courier',
				service: 'spedisciOnline',
			},
			bartolini: {
				active: false,
				setting: {
					cliente: '',
					password: '',
				},
				type: 'courier',
				service: 'bartolini',
			},
			dhl: {
				active: false,
				setting: {
					user: '',
					password: '',
					account_number: '',
					test_mode: false,
				},
				type: 'courier',
				service: 'dhl',
			},
			ups: {
				active: false,
				setting: {
					user: '',
					password: '',
					access_license_number: '',
					account_number: '',
					test_mode: false,
				},
				type: 'courier',
				service: 'ups',
			},
			fedex: {
				active: false,
				setting: {
					client_id: '',
					client_secret: '',
					tracking_client_id: '',
					tracking_client_secret: '',
					account_number: '',
					test_mode: false,
				},
				type: 'courier',
				service: 'fedex',
			},

			// righe della tabella: indice = argomento di saveSetting/extension, key = oggetto in data
			servizi: [
				{
					indice: 0,
					key: 'spedisciOnline',
					connessione: 'spedisciOnline',
					nome: 'Spediamo',
					logo: require('@/assets/images/corrieri/spediamo.svg'),
					logoLargo: true,
					webhook: 'https://api.azseller.app/api/v1/nocors/couriers/spediscionline',
					campi: [
						{ key: 'secret', label: 'Secret Webhook', pieno: true },
						{ key: 'apikey', label: 'API Key' },
						{ key: 'endpoint', label: 'Endpoint' },
					],
				},
				{
					indice: 1,
					key: 'gls',
					connessione: 'gls',
					nome: 'GLS',
					logo: require('@/assets/images/corrieri/gls.svg'),
					logoLargo: true,
					campi: [
						{ key: 'SedeGls', label: 'Sede Gls' },
						{ key: 'CodiceClienteGls', label: 'Codice Cliente Gls' },
						{ key: 'PasswordClienteGls', label: 'Password Cliente Gls', tipo: 'password' },
						{ key: 'CodiceContrattoGls', label: 'Codice Contratto Gls (più contratti separati da virgola)' },
					],
				},
				{
					indice: 2,
					key: 'bartolini',
					connessione: 'bartolini',
					nome: 'BRT',
					logo: require('@/assets/images/corrieri/bartolini.svg'),
					logoLargo: true,
					campi: [
						{ key: 'cliente', label: 'Codice Cliente' },
						{ key: 'password', label: 'Password', tipo: 'password' },
						{ key: 'filiale_partenza', label: 'ID Filiale di Partenza' },
						{ key: 'rapporto_peso_volume', label: 'Rapporto peso/volume considerato' },
					],
				},
				{
					indice: 3,
					key: 'dhl',
					connessione: 'dhl',
					nome: 'DHL',
					logo: require('@/assets/images/corrieri/dhl.svg'),
					logoLargo: true,
					titoloSwitch: 'Opzioni',
					campi: [
						{ key: 'user', label: 'DHL User' },
						{ key: 'password', label: 'DHL Password', tipo: 'password' },
						{ key: 'account_number', label: 'DHL Account Number' },
						{ key: 'test_mode', label: 'Modalità Sandbox', tipo: 'switch' },
					],
				},
				{
					indice: 4,
					key: 'ups',
					connessione: 'ups',
					nome: 'UPS',
					logo: require('@/assets/images/corrieri/ups.svg'),
					logoLargo: true,
					titoloSwitch: 'Opzioni',
					campi: [
						{ key: 'user', label: 'UPS User' },
						{ key: 'password', label: 'UPS Password', tipo: 'password' },
						{ key: 'account_number', label: 'UPS Account Number' },
						{ key: 'access_license_number', label: 'UPS Access License Number' },
						{ key: 'test_mode', label: 'Modalità Sandbox', tipo: 'switch' },
					],
				},
				{
					indice: 5,
					key: 'fedex',
					connessione: 'fedex',
					nome: 'Fedex',
					logo: require('@/assets/images/corrieri/fedex.svg'),
					logoLargo: true,
					titoloSwitch: 'Opzioni',
					campi: [
						{ key: 'client_id', label: 'Client Id' },
						{ key: 'client_secret', label: 'Client secret', tipo: 'password' },
						{ key: 'tracking_client_id', label: 'Tracking Client Id' },
						{ key: 'tracking_client_secret', label: 'Tracking Client secret', tipo: 'password' },
						{ key: 'account_number', label: 'Account Number', pieno: true },
						{ key: 'test_mode', label: 'Modalità Sandbox', tipo: 'switch' },
					],
				},
			],
		};
	},
	filters: {
		fixed: function (value) {
			if (!+value) return '';
			return _.round(value, 2);
		},
	},
	async created() {
		this.setPreload(true);
		let promises = [];
		promises.push(this.fetchSettings());
		promises.push(this.fetchService(['gls', 'spedisciOnline', 'dhl', 'ups', 'bartolini', 'fedex']));
		await Promise.all(promises);

		this.setPreload(false);

		let gls = _.find(this.getServices, set => {
			return set.service === 'gls';
		});
		if (gls) {
			this.gls = gls;
		}
		let spedisciOnline = _.find(this.getServices, set => {
			return set.service === 'spedisciOnline';
		});
		if (spedisciOnline) {
			this.spedisciOnline = spedisciOnline;
		}
		let dhl = _.find(this.getServices, set => {
			return set.service === 'dhl';
		});
		if (dhl) {
			this.dhl = dhl;
		}
		let ups = _.find(this.getServices, set => {
			return set.service === 'ups';
		});
		if (ups) {
			this.ups = ups;
		}

		let bartolini = _.find(this.getServices, set => {
			return set.service === 'bartolini';
		});
		if (bartolini) {
			this.bartolini = bartolini;
		}

		let fedex = _.find(this.getServices, set => {
			return set.service === 'fedex';
		});
		if (fedex) {
			this.fedex = fedex;
		}
	},

	components: {
		TourOverlay,
		KeyValueCard,
		ServicePanel,
		MarketplaceConnectionCheck,
	},
	computed: {
		// sotto i 769px le righe diventano card
		mobileCards() {
			return this.$vuetify.breakpoint.width < 769;
		},
		...mapGetters({
			getAutenticate: 'profile/getAutenticate',
			getToken: 'profile/getToken',
			getId: 'profile/getId',
			getUrl: 'settings/getUrl',

			getDialog: 'settings/getDialog',
			getPreload: 'settings/getPreload',
			getSnackbar: 'snackbars/getSnackbar',
			getColor: 'snackbars/getColor',
			getMultiline: 'snackbars/getMultiline',
			getTimeout: 'snackbars/getTimeout',
			getVertical: 'snackbars/getVertical',
			getText: 'snackbars/getText',
			getSettings: 'settings/getSetting',
			getDrawerFilter: 'settings/getDrawerFilter',

			getServices: 'services/getServices',
		}),
	},

	methods: {
		...mapMutations({
			setLogout: 'profile/setLogout',
			setDialog: 'settings/setDialog',
			setPreload: 'settings/setPreload',
			setSnackbar: 'snackbars/setSnackbar',
			setClearError: 'settings/setClearError',
			setMessages: 'settings/setMessages',
			setExistFilter: 'settings/setExistFilter',
			setDrawerFilter: 'settings/setDrawerFilter',
		}),
		...mapActions({
			fetchSettings: 'settings/asyncFetchData',
			fetchService: 'services/getServiceFetch',

			destroyData: 'settings/destroyData',
			setSettings: 'settings/updateData',
			setService: 'services/updateData',
		}),

		onResize() {
			this.isMobile = window.innerWidth < 769;
		},

		saveSetting(item) {
			let payload;
			switch (item) {
				case 0:
					payload = this.spedisciOnline;
					this.setPreload(true);
					break;
				case 1:
					payload = this.gls;
					this.setPreload(true);
					break;
				case 2:
					payload = this.bartolini;
					this.setPreload(true);
					break;
				case 3:
					payload = this.dhl;
					this.setPreload(true);
					break;
				case 4:
					payload = this.ups;
					this.setPreload(true);
					break;
				case 5:
					payload = this.fedex;
					this.setPreload(true);
					break;
			}
			let url = 'services/update';
			axios
				.post(`${this.getUrl}${url}`, payload, {
					headers: { Authorization: `Bearer ${this.getToken}` },
				})
				.then(({ data }) => {
					this.setService(data.data);
					this.setPreload(false);
					this.snackbar.color = 'success';
					this.snackbar.text = 'Operazione effettuata con  successo';
					this.snackbar.snackbar = true;
					this.snackbar.mode = 'multi-line';
					this.snackbar.timeout = 5000;
				})
				.catch(err => {
					if (err.response) {
						let errors = err.response.data.error;
						if (errors) {
							if (_.isArray(errors)) {
								errors.forEach(value => {
									this.messages[value.param] = value.msg;
								});
							} else {
								err.message = errors;
							}
						}

						this.snackbar.color = 'error';
						this.snackbar.text = err.message;
						this.snackbar.snackbar = true;
						this.snackbar.mode = 'multi-line';
						this.snackbar.timeout = 5000;
						this.setPreload(false);
						if (err.response.status === 401) {
							this.setLogout();
							this.$router.push('/login');
						}
					}
				});
		},
		extension(item) {
			let check = this.selected.includes(item);
			if (!check) {
				this.selected.push(item);
			} else {
				let index = this.selected.indexOf(item);
				this.selected.splice(index, 1);
			}
		},
		openConnectionCheck(service) {
			this.connectionCheck.service = service;
			this.connectionCheck.open = true;
		},
		checkpresenza(item) {
			return this.selected.includes(item);
		},
		// oggetto in data del corriere: created() lo sostituisce, quindi va letto ogni volta
		modello(servizio) {
			return this[servizio.key];
		},
	},
};
</script>

<style></style>

<style scoped>
/* lista compatta: la riga aperta si colora e sotto compare il riquadro di configurazione */
.as-list-row {
	cursor: pointer;
}
.as-list-row--open,
.as-list-row--open:hover {
	background: #f3f6fa !important;
}
.as-expanded,
.as-expanded:hover {
	background: transparent !important;
}
/* vista card: niente layout a colonne, ogni riga e' un blocco e la card prende il 100% */
.table-cards ::v-deep table {
	display: block;
	width: 100%;
}
.courier-cards,
.courier-cards tr {
	display: block;
	width: 100%;
}
.courier-cards tr,
.courier-cards tr:hover {
	background: transparent !important;
}
.courier-cards td {
	display: block;
	width: 100%;
	border-bottom: none !important;
	height: auto !important;
}
/* respiro tra le card e il bordo della card che contiene la tabella */
.courier-cards tr:first-child td {
	padding-top: 12px !important;
}
.courier-cards tr:last-child td {
	padding-bottom: 12px !important;
}
.courier-cards tr + tr td {
	padding-top: 8px !important;
}
.card-label {
	font-size: 14px;
	color: rgba(0, 0, 0, 0.6);
}
</style>
